/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Theme from "../../../utils/Theme";
import { Carousel, Tag, WhiteSpace, WingBlank } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import StarRatingComponent from "react-star-rating-component";
import CountdownLabel from "../../../components/CountdownLabel";
import AddToCartButton from "../../../components/AddToCartButton";
import LoadingIndicator from "../../../components/LoadingIndicator";
import * as foodSelectors from "../../../selectors/food";
import "./index.css";

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: white;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 15px 20px;
`;

const StyledSpaceBetweenContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledPrice = styled.span`
  font-weight: bold;
  color: black;
  font-size: 1.4em;
`;

const StyledRatingContainer = styled.div`
  font-size: 1em;
  margin-left: -1px;
`;

const StyledDescriptionContainer = styled.div`
  flex: 1;
  font-size: 0.9em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledDescription = styled.span`
  color: ${Theme.PrimaryColor};
  font-size: 1em;
`;

const StyledDescriptionContentContainer = styled.div`
  padding: 10px 0;
  text-align: start;
  line-height: 1.3em;
`;

const StyledAppliedFilterContentContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

class DetailsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }

  componentDidMount() {
    setTimeout(this.setState({ mounted: true }), 500);
  }

  getBanner = () => {
    const { item } = this.props;
    const { mounted } = this.state;
    const images = foodSelectors.getFoodImages(item);

    return mounted ? (
      <Carousel>
        {images && images.length > 0 ? (
          images.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={image.id + "-" + image.name}
              style={{
                width: "100%"
              }}
              onLoad={() => {
                window.dispatchEvent(new Event("resize"));
              }}
            />
          ))
        ) : (
          <img
            src={"https://via.placeholder.com/600x400"}
            alt="placeHolderImage"
            style={{ width: "100%" }}
            onLoad={() => {
              window.dispatchEvent(new Event("resize"));
            }}
          />
        )}
      </Carousel>
    ) : null;
  };

  render() {
    const { item, onItemAddToCart, isLoading } = this.props;
    const description = foodSelectors.getFoodItemDescription(item);
    const price = foodSelectors.getFoodPriceText(item);
    const preparationTime = foodSelectors.getFoodEstimateWaitTime(item);
    const rating = foodSelectors.getFoodReviewCount(item);
    const foodTagData = foodSelectors.getFoodTag(item);
    const isAvailable = foodSelectors.getFoodIsAvailable(item);

    return (
      <StyledContentContainer className="no-shrink-class">
        {isLoading ? <LoadingIndicator /> : null}
        {this.getBanner()}
        <WhiteSpace size={"lg"} />
        <StyledSpaceBetweenContainer>
          <StyledInfoContainer>
            <StyledPrice>{price}</StyledPrice>
            <WhiteSpace size={"sm"} />
            <StyledRatingContainer>
              <StarRatingComponent
                name={"productItemRating"}
                editing={false}
                starCount={5}
                value={rating}
                starColor={Theme.PrimaryColor}
                emptyStarColor={"lightgrey"}
              />
            </StyledRatingContainer>
            <WhiteSpace size={"md"} />
            <CountdownLabel
              title={
                <FormattedMessage
                  id="product.eta"
                  defaultMessage="Preparation Times"
                  values={{ time: preparationTime }}
                />
              }
              fontSize={"1.1em"}
            />
          </StyledInfoContainer>
          <AddToCartButton
            disabled={!isAvailable}
            showText
            onClicked={() => onItemAddToCart && onItemAddToCart()}
          />
        </StyledSpaceBetweenContainer>
        <WhiteSpace size={"md"} />
        <StyledAppliedFilterContentContainer>
          {foodTagData && foodTagData.length > 0
            ? foodTagData.map((tag, index) => (
                <div
                  key={index}
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  {index !== 0 ? <WingBlank size={"sm"} /> : null}
                  <Tag className={"product-details-tag"}>{tag.name}</Tag>
                </div>
              ))
            : null}
        </StyledAppliedFilterContentContainer>
        <WhiteSpace size={"lg"} />
        <StyledDescriptionContainer>
          <StyledDescription>
            {description && (
              <FormattedMessage
                id="product.tab.details.description.title"
                defaultMessage="Descriptions"
                description="Description Title"
              />
            )}
          </StyledDescription>
          <WhiteSpace size={"sm"} />
          <StyledDescriptionContentContainer
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </StyledDescriptionContainer>
        <WhiteSpace size={"lg"} />
      </StyledContentContainer>
    );
  }
}

DetailsSection.propTypes = {
  item: PropTypes.object.isRequired,
  onItemAddToCart: PropTypes.func,
  isLoading: PropTypes.bool
};

export default DetailsSection;



// WEBPACK FOOTER //
// ./src/containers/ProductPage/DetailsSection/index.js